import Vue from 'vue';
import './inlineFilesDirective.js'

// Clear search text after selecting an item in multiple v-autocomplete
Vue.mixin({
    mounted() {
        if (this.$options.name === 'v-autocomplete') {
            const vm = this
            const origSelectItem = vm.selectItem
            vm.selectItem = function(item) {
                origSelectItem.call(vm, item)
                if (vm.multiple) {
                    vm.$nextTick(() => {
                        vm.internalSearch = null
                    })
                }
            }
        }
    }
})

Vue.directive('longpress', {
    bind: function (el, binding, vNode) {
        // Make sure expression provided is a function
        if (typeof binding.value !== 'function') {
            // Fetch name of component
            const compName = vNode.context.name
            // pass warning to console
            let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}' ` }

            console.warn(warn)
        }

        // Define variable
        let pressTimer = null

        // Define funtion handlers
        // Create timeout ( run function after 1s )
        let start = (e) => {

            if (e.type === 'click' && e.button !== 0) {
                return;
            }

            if (pressTimer === null) {
                pressTimer = setTimeout(() => {
                    // Run function
                    handler()
                }, 1500)
            }
        }

        // Cancel Timeout
        let cancel = (e) => {
            // Check if timer has a value or not
            if (pressTimer !== null) {
                clearTimeout(pressTimer)
                pressTimer = null
            }
        }
        // Run Function
        const handler = (e) => {
            binding.value(e)
        }

        // Add Event listeners
        el.addEventListener("mousedown", start);
        el.addEventListener("touchstart", start);
        // Cancel timeouts if this events happen
        el.addEventListener("click", cancel);
        el.addEventListener("mouseout", cancel);
        el.addEventListener("touchend", cancel);
        el.addEventListener("touchcancel", cancel);
    }
})


Vue.directive('draggable', {
  inserted(el) {
    const handle = el.querySelector('.v-card__title')
    if (!handle) return

    const dialog = el.closest('.v-dialog')
    if (!dialog) return

    dialog.style.transform = ''

    let isDragging = false
    let translateX = 0, translateY = 0
    let rafId = null

    const resetPosition = () => {
      translateX = 0
      translateY = 0
      dialog.style.transform = ''
    }

    handle.style.cursor = 'grab'
    handle.style.userSelect = 'none'

    const onMouseMove = (e) => {
      if (!isDragging) return
      translateX += e.movementX
      translateY += e.movementY
      if (rafId) return
      rafId = requestAnimationFrame(() => {
        dialog.style.transform = `translate(${translateX}px, ${translateY}px)`
        rafId = null
      })
    }

    const onMouseUp = () => {
      isDragging = false
      handle.style.cursor = 'grab'
      dialog.style.willChange = ''
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
    }

    const onMouseDown = (e) => {
      if (e.target.closest('button, a, input, textarea, [role="button"]')) return
      isDragging = true
      handle.style.cursor = 'grabbing'
      dialog.style.willChange = 'transform'
      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    }

    handle.addEventListener('mousedown', onMouseDown)

    // Reset position when dialog is hidden or goes fullscreen
    const overlay = dialog.closest('.v-dialog__content')
    const observer = new MutationObserver(() => {
      const isHidden = overlay && !overlay.classList.contains('v-dialog__content--active')
      const isFullscreen = dialog.classList.contains('v-dialog--fullscreen')
      if (isHidden || isFullscreen) resetPosition()
    })
    if (overlay) observer.observe(overlay, { attributes: true, attributeFilter: ['class'] })
    observer.observe(dialog, { attributes: true, attributeFilter: ['class'] })

    el._draggableCleanup = () => {
      handle.removeEventListener('mousedown', onMouseDown)
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
      observer.disconnect()
    }
  },

  unbind(el) {
    if (el._draggableCleanup) {
      el._draggableCleanup()
      delete el._draggableCleanup
    }
  }
})


Vue.directive('cell-expand', {
  inserted(el) {
    const onEnter = () => {
      if (el.scrollWidth <= el.clientWidth) return
      const w = el.offsetWidth + 'px'
      el.style.width = w
      el.style.minWidth = w
      el.style.maxWidth = w
      el.style.whiteSpace = 'normal'
      el.style.wordBreak = 'break-word'
      el.style.overflow = 'visible'
      el.style.height = 'auto'
      el.style.zIndex = '10'
      el.style.position = 'relative'
    }

    const onLeave = () => {
      el.style.width = ''
      el.style.minWidth = ''
      el.style.maxWidth = ''
      el.style.whiteSpace = ''
      el.style.wordBreak = ''
      el.style.overflow = ''
      el.style.height = ''
      el.style.zIndex = ''
      el.style.position = ''
    }

    el.addEventListener('mouseenter', onEnter)
    el.addEventListener('mouseleave', onLeave)

    el._cellExpandCleanup = () => {
      onLeave()
      el.removeEventListener('mouseenter', onEnter)
      el.removeEventListener('mouseleave', onLeave)
    }
  },

  unbind(el) {
    if (el._cellExpandCleanup) {
      el._cellExpandCleanup()
      delete el._cellExpandCleanup
    }
  }
})


Vue.directive('dragpress', {
    bind: function (el, binding, vNode) {
        // Make sure expression provided is a function
        if (typeof binding.value !== 'function') {
            // Fetch name of component
            const compName = vNode.context.name
            // pass warning to console
            let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}' ` }

            console.warn(warn)
        }

        // Define variable
        let pressTimer = null

        // Define funtion handlers
        // Create timeout ( run function after 1s )
        let start = (e) => {

            if (e.type === 'click' && e.button !== 0) {
                return;
            }

            if (e.which === 3) {
                return;
            }

            if (pressTimer === null) {
                pressTimer = setTimeout(() => {
                    // Run function
                    handler()
                }, 400)
            }
        }

        // Cancel Timeout
        let cancel = (e) => {
            // Check if timer has a value or not
            if (pressTimer !== null) {
                clearTimeout(pressTimer)
                pressTimer = null
            }
        }
        // Run Function
        const handler = (e) => {
            let s = binding.arg
            binding.value(s, e)
        }

        // Add Event listeners
        el.addEventListener("mousedown", start);
        el.addEventListener("touchstart", start);
        // Cancel timeouts if this events happen
        el.addEventListener("click", cancel);
        el.addEventListener("mouseout", cancel);
        el.addEventListener("touchend", cancel);
        el.addEventListener("touchcancel", cancel);
    }
})